(function () {
  'use strict';

  var GOAL_RANGES = {
    fat_loss: { min: 1.6, max: 2.2 },
    maintain: { min: 1.4, max: 2.0 },
    build_muscle: { min: 1.6, max: 2.2 },
  };

  var COPY = {
    nl: {
      eyebrow: 'MUSKLE · MJ App',
      title: 'Protein Calculator',
      intro:
        'Bereken een veilige dagelijkse eiwitrange op basis van je lichaamsgewicht en doel. Gebruik dit als praktische richtlijn voor je voeding.',
      accountNote: 'Geen account nodig. Log later in om je resultaat op te slaan.',
      backLabel: 'Terug naar MJ Apps',
      langToggle: 'Taal',
      weightLabel: 'Gewicht (kg)',
      weightPlaceholder: 'Bijv. 80',
      goalLabel: 'Doel',
      goalFatLoss: 'Afvallen',
      goalMaintain: 'Onderhouden',
      goalBuild: 'Spiermassa opbouwen',
      trainingLabel: 'Training per week',
      training02: '0–2 dagen',
      training34: '3–4 dagen',
      training5: '5+ dagen',
      dietLabel: 'Voedingstype (optioneel)',
      dietNormal: 'Normaal',
      dietVegetarian: 'Vegetarisch',
      dietVegan: 'Vegan',
      calculateBtn: 'Bereken mijn eiwitbehoefte',
      resultTitle: 'Jouw eiwitrange',
      resultEmpty: 'Vul je gegevens in en klik op berekenen om je dagelijkse eiwitrange te zien.',
      resultRange: '{min}–{max} g eiwit per dag',
      commentaryPracticalTitle: 'Praktische start',
      commentaryPracticalText:
        'Mik eerst op het midden van je range. Pas daarna aan op basis van honger, herstel, trainingsdoel en voortgang.',
      commentaryMealsTitle: 'Verdeling over de dag',
      commentaryMealsText:
        'Verdeel je eiwitten over de dag, bijvoorbeeld over 3–5 eetmomenten. Een praktische richtlijn is vaak 20–40 g eiwit per eetmoment, afhankelijk van lichaamsgewicht, productkeuze en maaltijdgrootte.',
      commentarySafetyTitle: 'Bron & veiligheid',
      commentarySafetyText:
        'Gebaseerd op sportvoedingsrichtlijnen zoals ISSN/ACSM. Dit is een richtlijn voor gezonde volwassenen, geen medisch advies.',
      sourceNote:
        'Bij nierproblemen, zwangerschap, medische aandoeningen of twijfel: overleg met een arts of diëtist.',
      productsTitle: 'Aanbevolen producten',
      productsEmpty: 'Producttips volgen later in deze app.',
      errorWeight: 'Vul een geldig gewicht in (20–250 kg).',
      goalTitle: {
        fat_loss: 'Afvallen',
        maintain: 'Onderhouden',
        build_muscle: 'Spiermassa opbouwen',
      },
      goalText: {
        fat_loss:
          'Bij afvallen is genoeg eiwit vooral bedoeld om je spiermassa beter te helpen behouden tijdens een calorietekort. Het eiwit zelf zorgt niet automatisch voor vetverlies; je totale voeding, calorie-inname, training en herstel blijven bepalend.',
        maintain:
          'Voor onderhoud is deze range bedoeld als praktische dagelijkse eiwitrichtlijn rond je huidige lichaamsgewicht en activiteit. Je hoeft niet altijd de bovenkant van de range te halen als je voeding, herstel en training stabiel zijn.',
        build_muscle:
          'Voor spiermassa opbouwen helpt voldoende eiwit om herstel en spieropbouw te ondersteunen, vooral in combinatie met krachttraining en genoeg totale energie. Meer eiwit is niet automatisch beter als je totale voeding niet klopt.',
      },
      trainingText: {
        low: 'Met weinig training is de onderkant tot het midden van de range meestal een logische start. Focus vooral op consistent eten, voldoende beweging en herstel.',
        mid: 'Bij regelmatige training is het midden van de range een praktische start. Kijk daarna naar herstel, verzadiging, progressie en hoe haalbaar het is in je dagelijkse voeding.',
        high: 'Bij veel training kun je richting de bovenkant van de range gaan, vooral als herstel, spierbehoud of spieropbouw belangrijk is. Blijf wel praktisch: meer is niet altijd nodig.',
      },
    },
    en: {
      eyebrow: 'MUSKLE · MJ App',
      title: 'Protein Calculator',
      intro:
        'Calculate a safe daily protein range based on your body weight and goal. Use this as practical guidance for your nutrition.',
      accountNote: 'No account needed. Later you can log in to save your result.',
      backLabel: 'Back to MJ Apps',
      langToggle: 'Language',
      weightLabel: 'Weight (kg)',
      weightPlaceholder: 'e.g. 80',
      goalLabel: 'Goal',
      goalFatLoss: 'Fat loss',
      goalMaintain: 'Maintain',
      goalBuild: 'Build muscle',
      trainingLabel: 'Training per week',
      training02: '0–2 days',
      training34: '3–4 days',
      training5: '5+ days',
      dietLabel: 'Nutrition type (optional)',
      dietNormal: 'Normal',
      dietVegetarian: 'Vegetarian',
      dietVegan: 'Vegan',
      calculateBtn: 'Calculate my protein needs',
      resultTitle: 'Your protein range',
      resultEmpty: 'Enter your details and click calculate to see your daily protein range.',
      resultRange: '{min}–{max} g protein per day',
      commentaryPracticalTitle: 'Practical starting point',
      commentaryPracticalText:
        'Aim first for the middle of your range. Then adjust based on hunger, recovery, training goals and progress.',
      commentaryMealsTitle: 'Spread across the day',
      commentaryMealsText:
        'Spread your protein across the day, for example over 3–5 eating moments. A practical guideline is often 20–40 g protein per eating moment, depending on body weight, product choice and meal size.',
      commentarySafetyTitle: 'Source & safety',
      commentarySafetyText:
        'Based on sports nutrition guidance such as ISSN/ACSM. This is guidance for healthy adults, not medical advice.',
      sourceNote:
        'If you have kidney problems, pregnancy, medical conditions or doubts: consult a doctor or dietitian.',
      productsTitle: 'Recommended products',
      productsEmpty: 'Product tips will follow later in this app.',
      errorWeight: 'Enter a valid weight (20–250 kg).',
      goalTitle: {
        fat_loss: 'Fat loss',
        maintain: 'Maintain',
        build_muscle: 'Build muscle',
      },
      goalText: {
        fat_loss:
          'During fat loss, enough protein is mainly intended to help you preserve muscle mass during a calorie deficit. Protein alone does not automatically cause fat loss; your overall nutrition, calorie intake, training and recovery remain decisive.',
        maintain:
          'For maintenance, this range is intended as a practical daily protein guideline around your current body weight and activity. You do not always need to reach the top of the range if your nutrition, recovery and training are stable.',
        build_muscle:
          'For building muscle, sufficient protein helps support recovery and muscle growth, especially combined with strength training and enough total energy. More protein is not automatically better if your overall nutrition is not in order.',
      },
      trainingText: {
        low: 'With little training, the lower to middle part of the range is usually a logical starting point. Focus mainly on consistent eating, enough movement and recovery.',
        mid: 'With regular training, the middle of the range is a practical starting point. Then look at recovery, satiety, progress and how feasible it is in your daily nutrition.',
        high: 'With heavy training, you can aim toward the upper part of the range, especially if recovery, muscle preservation or muscle building matters. Stay practical: more is not always needed.',
      },
    },
  };

  function init(root) {
    if (!root || root.dataset.mjProteinInit === '1') return;
    root.dataset.mjProteinInit = '1';

    var lang = root.dataset.defaultLang === 'en' ? 'en' : 'nl';
    var els = {
      langBtns: root.querySelectorAll('[data-mj-lang]'),
      eyebrow: root.querySelector('[data-mj-copy="eyebrow"]'),
      title: root.querySelector('[data-mj-copy="title"]'),
      intro: root.querySelector('[data-mj-copy="intro"]'),
      accountNote: root.querySelector('[data-mj-copy="accountNote"]'),
      back: root.querySelector('[data-mj-copy="backLabel"]'),
      weightLabel: root.querySelector('[data-mj-copy="weightLabel"]'),
      goalLabel: root.querySelector('[data-mj-copy="goalLabel"]'),
      trainingLabel: root.querySelector('[data-mj-copy="trainingLabel"]'),
      dietLabel: root.querySelector('[data-mj-copy="dietLabel"]'),
      calculateBtn: root.querySelector('[data-mj-action="calculate"]'),
      resultTitle: root.querySelector('[data-mj-copy="resultTitle"]'),
      resultEmpty: root.querySelector('[data-mj-result-empty]'),
      resultPanel: root.querySelector('[data-mj-result-panel]'),
      resultRange: root.querySelector('[data-mj-result-range]'),
      resultGoalTitle: root.querySelector('[data-mj-result-goal-title]'),
      resultGoalText: root.querySelector('[data-mj-result-goal-text]'),
      resultTrainingTitle: root.querySelector('[data-mj-result-training-title]'),
      resultTrainingText: root.querySelector('[data-mj-result-training-text]'),
      commentaryPracticalTitle: root.querySelector('[data-mj-copy="commentaryPracticalTitle"]'),
      commentaryPracticalText: root.querySelector('[data-mj-copy="commentaryPracticalText"]'),
      commentaryMealsTitle: root.querySelector('[data-mj-copy="commentaryMealsTitle"]'),
      commentaryMealsText: root.querySelector('[data-mj-copy="commentaryMealsText"]'),
      commentarySafetyTitle: root.querySelector('[data-mj-copy="commentarySafetyTitle"]'),
      commentarySafetyText: root.querySelector('[data-mj-copy="commentarySafetyText"]'),
      productsTitle: root.querySelector('[data-mj-copy="productsTitle"]'),
      productsEmpty: root.querySelector('[data-mj-copy="productsEmpty"]'),
      error: root.querySelector('[data-mj-error]'),
      weight: root.querySelector('[data-mj-input="weight"]'),
      goal: root.querySelectorAll('[data-mj-input="goal"]'),
      training: root.querySelectorAll('[data-mj-input="training"]'),
      diet: root.querySelector('[data-mj-input="diet"]'),
    };

    function t(key) {
      var parts = key.split('.');
      var val = COPY[lang];
      for (var i = 0; i < parts.length; i += 1) {
        if (!val) return key;
        val = val[parts[i]];
      }
      return val || key;
    }

    function applyCopy() {
      root.querySelectorAll('[data-mj-copy]').forEach(function (node) {
        var key = node.getAttribute('data-mj-copy');
        if (!key || key === 'backLabel') return;
        var text = t(key);
        if (typeof text === 'string') node.textContent = text;
      });

      if (els.back) els.back.textContent = t('backLabel');
      if (els.weight) els.weight.placeholder = t('weightPlaceholder');
      if (els.calculateBtn) els.calculateBtn.textContent = t('calculateBtn');

      root.querySelectorAll('[data-mj-option="goal"]').forEach(function (node) {
        var opt = node.getAttribute('data-mj-option-value');
        if (opt === 'fat_loss') node.textContent = t('goalFatLoss');
        if (opt === 'maintain') node.textContent = t('goalMaintain');
        if (opt === 'build_muscle') node.textContent = t('goalBuild');
      });

      root.querySelectorAll('[data-mj-option="training"]').forEach(function (node) {
        var opt = node.getAttribute('data-mj-option-value');
        if (opt === '0-2') node.textContent = t('training02');
        if (opt === '3-4') node.textContent = t('training34');
        if (opt === '5+') node.textContent = t('training5');
      });

      root.querySelectorAll('[data-mj-option="diet"]').forEach(function (node) {
        var opt = node.getAttribute('data-mj-option-value');
        if (opt === 'normal') node.textContent = t('dietNormal');
        if (opt === 'vegetarian') node.textContent = t('dietVegetarian');
        if (opt === 'vegan') node.textContent = t('dietVegan');
      });

      els.langBtns.forEach(function (btn) {
        var isActive = btn.getAttribute('data-mj-lang') === lang;
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        btn.classList.toggle('mj-app__lang-btn--active', isActive);
      });

      root.setAttribute('data-mj-lang', lang);
    }

    function getSelected(name) {
      var nodes = root.querySelectorAll('[data-mj-input="' + name + '"]');
      for (var i = 0; i < nodes.length; i += 1) {
        if (nodes[i].checked) return nodes[i].value;
      }
      return '';
    }

    function applyCommentary(goal, training) {
      if (els.resultGoalTitle) els.resultGoalTitle.textContent = t('goalTitle.' + goal);
      if (els.resultGoalText) els.resultGoalText.textContent = t('goalText.' + goal);

      var trainKey = training === '0-2' ? 'low' : training === '5+' ? 'high' : 'mid';
      var trainTitleKey = training === '0-2' ? 'training02' : training === '5+' ? 'training5' : 'training34';
      if (els.resultTrainingTitle) els.resultTrainingTitle.textContent = t(trainTitleKey);
      if (els.resultTrainingText) els.resultTrainingText.textContent = t('trainingText.' + trainKey);
    }

    function calculate() {
      if (els.error) {
        els.error.hidden = true;
        els.error.textContent = '';
      }

      var weight = parseFloat(String(els.weight && els.weight.value).replace(',', '.'));
      if (!weight || weight < 20 || weight > 250) {
        if (els.error) {
          els.error.textContent = t('errorWeight');
          els.error.hidden = false;
        }
        return;
      }

      var goal = getSelected('goal') || 'maintain';
      var training = getSelected('training') || '3-4';
      var range = GOAL_RANGES[goal] || GOAL_RANGES.maintain;
      var minG = Math.round(weight * range.min);
      var maxG = Math.round(weight * range.max);

      if (els.resultRange) {
        els.resultRange.textContent = t('resultRange')
          .replace('{min}', String(minG))
          .replace('{max}', String(maxG));
      }
      applyCommentary(goal, training);
      if (els.resultEmpty) els.resultEmpty.hidden = true;
      if (els.resultPanel) els.resultPanel.hidden = false;
      root.classList.add('mj-app--has-result');
    }

    els.langBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = btn.getAttribute('data-mj-lang');
        if (next === 'nl' || next === 'en') {
          lang = next;
          applyCopy();
          if (root.classList.contains('mj-app--has-result')) calculate();
        }
      });
    });

    if (els.calculateBtn) {
      els.calculateBtn.addEventListener('click', calculate);
    }

    applyCopy();
  }

  document.querySelectorAll('[data-mj-protein-app]').forEach(init);
})();
